import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation } from "@tanstack/react-query";
import { OPEN_POSITION_RESOURCE } from "./use-open-position-search.query";

export const OPEN_POSITION_SYNC_V1_API_PATH = `/v1/${OPEN_POSITION_RESOURCE}/{openPositionUuid}/sync-v1` as const;

export type OpenPositionSyncV1Response =
  paths[typeof OPEN_POSITION_SYNC_V1_API_PATH]["post"]["responses"][202]["content"]["application/json"];

export function useOpenPositionSyncV1Mutation() {
  return useMutation<OpenPositionSyncV1Response, Error, { openPositionUuid: string }>({
    mutationFn: async ({ openPositionUuid }) => {
      const response = await alphartisApiAxios.post<OpenPositionSyncV1Response>(
        OPEN_POSITION_SYNC_V1_API_PATH.replace("{openPositionUuid}", openPositionUuid),
      );
      return response.data;
    },
  });
}
